export default __webpack_public_path__ + "static/media/marker.4d443415.svg";